import React, { useState } from 'react';

import { Button, Modal } from 'semantic-ui-react';

interface AddItemDialogProps {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: any;
}
export default function AddItemDialog(props: AddItemDialogProps) {
  const [open, setOpen] = useState(false);

  const handleClose = () => setOpen(false);

  return (
    <span className="action-panel">
      <Modal
        trigger={<Button content={props.title} basic color="black" icon="add" onClick={() => setOpen(true)}></Button>}
        open={open}
        onClose={handleClose}
      >
        <Modal.Header>{props.title}</Modal.Header>
        <Modal.Content>
          <props.form onClose={handleClose} submitted={handleClose} />
        </Modal.Content>
      </Modal>
    </span>
  );
}
